import React from 'react';
import Header from './container/Header/Header';
import { Attribution } from "./components";


function App() {
  return (
    <div className="app">
      <Header />
      <Attribution />
    </div>
  );
}

export default App;
